(function () {
    'use strict';

    angular
        .module('recomRoutes', [
            'recomControllers'
        ])
        .config(router);

    router.$inject = ['$stateProvider'];

    function router($stateProvider) {

        $stateProvider

            // Recom Home
            .state('recom', {
                url: '/recom/{BusinessUnitCode:string}/GovernanceProcess',
                abstract: true,
                resolve: {
                    businessUnit: ['recomService', '$stateParams', 'errorManagementService', function (recomService, $stateParams, errorManagementService) {

                        return recomService.getBusinessUnitByCode($stateParams.BusinessUnitCode)
                            .then(function (businessUnit) {
                                return businessUnit
                            }, function (response) {
                                errorManagementService.manageError(response)
                            })
                    }],
                    fiscalYears: ['grcGovernanceProcessService', function (service) {
                        return service.getFiscalYears();
                    }]
                },
                template: '<div ui-view="govProcess"></div>'
            })

            // View Active Gov Process
            .state('recom.listGovernanceProcess', {
                url: '/Active',
                views: {
                    'govProcess@recom': {
                        resolve : {
                            governanceProcess: ['businessUnit', 'recomService', function (businessUnit, service) {
                                return service.getActiveGovernanceProcessByRecomBusinessUnit(businessUnit.RecomBusinessUnitID);
                            }]
                        },
                        templateUrl: require('./governanceProcessList.tpl.html'),
                        controller: 'GovernanceProcessListController'
                    }
                }
            })

            // Add Gov Process
            .state('recom.addGovernanceProcess', {
                url: '/Add',
                views: {
                    'govProcess@recom': {
                        resolve : {
                            governanceProcess: ['businessUnit', function (businessUnit) {
                                return {RecomBusinessUnitID: businessUnit.RecomBusinessUnitID}
                            }]
                        },
                        templateUrl: require('./governanceProcessEdit.tpl.html'),
                        controller: 'GovernanceProcessEditController'
                    }
                }
            })

            // Edit Gov Process
            .state('recom.editGovernanceProcess', {
                url: '/{GovernanceProcessID:int}',
                views: {
                    'govProcess@recom': {
                        resolve: {
                            governanceProcess: ['$stateParams', 'grcGovernanceProcessService', function ($stateParams, service) {
                                return service.getById($stateParams.GovernanceProcessID);
                            }]
                        },
                        templateUrl: require('./governanceProcessEdit.tpl.html'),
                        controller: 'GovernanceProcessEditController'
                    }
                }
            });
    }
})();